import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { NotificationProvider } from "./context/NotificationContext";
import { I18nProvider } from "../i18n/i18n";
import { AppProvider } from "./context/AppContext";

import { MainLayout } from "../components/layout/MainLayout";
import { LoginScreen } from "../modules/auth/LoginScreen";

import { DashboardModule } from "../modules/dashboard/DashboardModule";
import { ProcurementModule } from "../modules/procurement/ProcurementModule";
import { ReceivingModule } from "../modules/receiving/ReceivingModule";
import { InventoryModule } from "../modules/inventory/InventoryModule";
import { WarehouseModule } from "../modules/warehouse/WarehouseModule";
import { StockTransferModule } from "../modules/stockTransfer/StockTransferModule";
import { SalesModule } from "../modules/sales/SalesModule";
import { CustomersModule } from "../modules/customers/CustomersModule";
import { SuppliersModule } from "../modules/suppliers/SuppliersModule";
import { FinanceModule } from "../modules/finance/FinanceModule";
import { EmployeesModule } from "../modules/employees/EmployeesModule";
import { BatchExpiryModule } from "../modules/batchExpiry/BatchExpiryModule";
import { DeadStockModule } from "../modules/deadStock/DeadStockModule";
import { ReturnsModule } from "../modules/returns/ReturnsModule";
import { AnalyticsModule } from "../modules/analytics/AnalyticsModule";
import { NotificationsModule } from "../modules/notifications/NotificationsModule";
import { AuditLogModule } from "../modules/auditLog/AuditLogModule";
import { AccessControlModule } from "../modules/accessControl/AccessControlModule";
import { SettingsModule } from "../modules/settings/SettingsModule";

export function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <I18nProvider>
          <AuthProvider>
            <NotificationProvider>
              <AppProvider>
                <Routes>
                  <Route path="/login" element={<LoginScreen />} />

                  <Route path="/" element={<MainLayout />}>
                    <Route index element={<DashboardModule />} />
                    <Route path="procurement" element={<ProcurementModule />} />
                    <Route path="receiving" element={<ReceivingModule />} />
                    <Route path="inventory" element={<InventoryModule />} />
                    <Route path="warehouse" element={<WarehouseModule />} />
                    <Route path="stock-transfer" element={<StockTransferModule />} />
                    <Route path="sales" element={<SalesModule />} />
                    <Route path="customers" element={<CustomersModule />} />
                    <Route path="suppliers" element={<SuppliersModule />} />
                    <Route path="finance" element={<FinanceModule />} />
                    <Route path="employees" element={<EmployeesModule />} />
                    <Route path="batch-expiry" element={<BatchExpiryModule />} />
                    <Route path="dead-stock" element={<DeadStockModule />} />
                    <Route path="returns" element={<ReturnsModule />} />
                    <Route path="analytics" element={<AnalyticsModule />} />
                    <Route path="notifications" element={<NotificationsModule />} />
                    <Route path="audit-log" element={<AuditLogModule />} />
                    <Route path="access-control" element={<AccessControlModule />} />
                    <Route path="settings" element={<SettingsModule />} />
                  </Route>

                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </AppProvider>
            </NotificationProvider>
          </AuthProvider>
        </I18nProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
